/**
 * Constants for patient registration field names
 * Used to maintain consistency in form field references across the application
 */
export const PATIENT_FIELDS = {
  // Membership Information
  REGISTRATION_CODE: 'registration_code',
  MEMBERSHIP_NUMBER: 'membership_number',

  // Personal information
  FIRSTNAME: 'firstname',
  MIDDLENAME: 'middlename',
  LASTNAME: 'lastname',
  GENDER: 'gender',
  BIRTH_DATE: 'birth_date',
  
  // Contact information
  MOBILE_NUMBER: 'mobile_number',
  EMAIL: 'email',
  
  // Location information
  REGION: 'region',
  COUNTRY: 'country',
  PROVINCE: 'province',
  CITY: 'city',
  
  // Product interest information
  BRAND_OF_INTEREST: 'brand_of_interest',
  FIRST_TIME_TO_TRY_THIS_PRODUCT: 'first_time_to_try_this_product',
  INTEREST_FOR_FREE_NUTRITION_COUNSELING: 'interest_for_free_nutrition_counseling',

  // Mergers
  PRODUCT: 'product',
  PRESCRIBED_QUANTITY: 'prescribed_quantity',
  GODEX_DIAGNOSIS: 'godex_diagnosis',
  GODEX_DIAGNOSIS_REMARKS: 'godex_diagnosis_remarks',

  // Boegringer
  BI_INDICATION: 'bi_indication',

  // Natra
  AGE: 'age',
  BARANGAY: 'barangay',

  // Bayer
  STAGE_OF_PREGNANCY: 'stage_of_pregnancy',

  // Besins Heathcare Philippines
  HOSPITAL_CLINIC: 'hospital_clinic',

  // Mead Johnson
  HOME_ADDRESS: 'home_address',
  EXPECTED_DATE_OF_CHILDBIRTH: 'expected_date_of_childbirth',
  NUMBER_OF_CHILDREN_BELOW: 'number_of_children_below',
  FIRST_CHILD_AGE: "first_child_age",
  SECOND_CHILD_AGE: "second_child_age",
  THIRD_CHILD_AGE: "third_child_age",
} as const;

// Type definition for type safety when referencing field names
export type PatientFieldName = typeof PATIENT_FIELDS[keyof typeof PATIENT_FIELDS];